import { Logger } from '@/utils/logger';
import { Stack } from '@montugroup/design-system';
import { useMediaQuery, useTheme } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

const logger = new Logger('PrescriptionQrCode');

interface PrescriptionQrCodeProps {
  token: string;
}

export function PrescriptionQrCode({ token }: PrescriptionQrCodeProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!token) {
    logger.critical('token is null');
    return null;
  }

  return (
    <Stack
      sx={{
        ...(isMobile && {
          width: '100%',
          maxWidth: '200px',
          alignSelf: 'center',
        }),
        ...(!isMobile && {
          flexGrow: 1,
          maxWidth: '400px',
        }),
      }}
    >
      <QRCodeSVG
        value={token}
        style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
        fgColor={theme.palette.primary.main}
        level="H"
        imageSettings={{
          src: '/favicon.png',
          excavate: true,
          height: 32,
          width: 32,
        }}
      />
    </Stack>
  );
}
